<!--
  @Description 首页头
  @Date 2021-12-22
  @Author liushuo
-->
<template>
  <div class="home-heaedr-container">
    <!-- 标题 -->
    <div class="title-dv">
      <p>{{ title }}</p>
      <div class="title-overline"></div>
    </div>

    <!-- 扩展区域 -->
    <div class="expend-dv">
      <!-- 项目选择 -->
      <div class="project-select-dv" v-if="isShowProjectSelect">
        <el-select
          v-model="optionsValue"
          placeholder="请选择"
          @change="changeSelect"
        >
          <el-option
            v-for="item in projectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeHeader',
  props: {
    // 标题
    title: {
      type: String,
      default: '问题汇总',
    },
    // 是否显示项目下拉框
    isShowProjectSelect: {
      type: Boolean,
      default: () => false,
    },
  },
  mounted() {
    if (this.isShowProjectSelect) {
      // 获取产品类型下拉框值
      this.getSelectItem()
    }
  },
  activated() {
    if (this.isShowProjectSelect) {
      // 设置产品类型下拉框默认值
      this.setDefaultOptionsValue()
    }
  },
  data() {
    return {
      // 绑定的下拉框值
      optionsValue: '',
      // 产品类型选择项
      projectOptions: [],
    }
  },
  methods: {
    // 切换下拉框事件
    changeSelect(productionType) {
      this.$emit('changeSelect', productionType)
    },
    // 获取下拉框值
    async getSelectItem() {
      const { data: res } = await this.$http.get(
        '/Common/ProductVersionSet/select-item'
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      res.data.forEach((item) => {
        if (item.code === 'ProductionType') {
          this.projectOptions.push({
            value: item.value,
            label: item.name,
          })
        }
      })
      this.setDefaultOptionsValue()
    },

    // 赋值产品类型默认值
    setDefaultOptionsValue() {
      // 1.如果全局变量中已存放了默认值，则使用全局变量中的值
      if (this.$store.state.productType !== '') {
        this.optionsValue = this.$store.state.productType
      } else {
        // 2.全局变量中无值，则默认取产品类型的第一个值
        this.optionsValue = this.projectOptions[0]?.value
        // 3.将产品默认值保存在全局变量中供父组件使用
        this.$store.commit('set_productType', this.optionsValue)
      }
      // 4.注意！此处 getList 需保留，避免出现首次进入页面时，汇总页读取不到产品类型变量而进行全量查询
      this.$parent.getList(true, this.$parent.isSearchAll)
    },
  },
}
</script>

<style lang="less" scoped>
@title-width: 170px;

.home-heaedr-container {
  width: 100%;
  height: 80px;
  position: relative;
  box-shadow: #00000019 0px 1px 10px;
  display: flex;
}

.title-dv {
  width: 170px;
  height: 100%;
  font-size: 28px;
  font-family: PingFang SC;
  .fl;

  > p {
    z-index: 2;
  }

  .title-overline {
    width: 42px;
    height: 13px;
    position: absolute;
    background-color: @text-color;
    border-radius: 3px;
    bottom: 17px;
    left: 22px;
  }
}

.expend-dv {
  width: calc(100% - @title-width);
  height: 100%;
  .fl(flex, flex-end, center);

  // 项目选择
  .project-select-dv {
    height: 100%;
    width: 130px;
    margin: 0 20px;
    .fl;
  }
}

.search-dv {
  width: 50px;
  height: 50px;
  transition: all 0.2s;
  border-radius: 10px;
  .fl;

  > img {
    width: 30px;
    height: 30px;
  }
}

.search-dv:hover {
  cursor: pointer;
  background-color: #f8f8f8;
  transform: translate(4%, 4%);
  transition: all 0.2s;
}

/deep/ .el-input__inner {
  background-color: #4683e6;
  color: @text-color;
  font-size: 18px;
  border: none;
  transition: @normal-transition;
}

/deep/ .el-input__inner:hover {
  background-color: #5c91e7;
  transition: @normal-transition;
}

/deep/ .el-select .el-input .el-select__caret {
  color: @text-color;
}
</style>
